module.exports = __webpack_public_path__ + "img/mortimer_b1.130b3ec2.jpg";